import { Avatar } from '@zrsystem/ui';
import { useEffect, useId, useRef, useState } from 'react';

export interface ShellAccountMenuProps {
  email?: string | undefined;
  initials: string;
  onSignOut: () => void;
}

export function ShellAccountMenu({ email, initials, onSignOut }: ShellAccountMenuProps) {
  const displayLabel = email ?? 'Conta';
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const menuId = useId();

  useEffect(() => {
    if (!open) {
      return;
    }

    function onPointerDown(event: MouseEvent) {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return (
    <div ref={rootRef} className="shell-account-menu">
      <button
        type="button"
        className="shell-account-menu-trigger"
        aria-label="Conta"
        title={displayLabel}
        aria-expanded={open}
        aria-haspopup="menu"
        aria-controls={menuId}
        onClick={() => {
          setOpen((current) => !current);
        }}
      >
        <Avatar size="sm" aria-hidden>
          {initials}
        </Avatar>
      </button>

      {open ? (
        <div
          id={menuId}
          className="ctx-switcher-menu ctx-switcher-menu--viewport-end shell-account-menu-panel"
          role="menu"
        >
          <div className="shell-account-menu-header">{displayLabel}</div>
          <button
            type="button"
            role="menuitem"
            className="ctx-switcher-item"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            <span className="ctx-switcher-item-text">
              <span className="ctx-switcher-item-title">Logout</span>
            </span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
